import React, { useRef } from "react";
import { WEDDING } from "../utils/config";
import { useTilt } from "../hooks/useTilt";
import storyphoto from "../assets/photos/couple11.jpeg";

export default function MessageFromUs() {
  const cardRef = useRef(null);
  useTilt(cardRef, 7);

  return (
    <section
      id="message"
      style={{
        background: "linear-gradient(158deg,var(--forest) 0%,var(--deep) 100%)",
        padding: "96px 36px",
      }}
    >
      <div
        style={{
          maxWidth: "960px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1.1fr",
          gap: "60px",
          alignItems: "center",
        }}
        className="grid-2-mobile"
      >
        {/* 3D photo card */}
        <div
          ref={cardRef}
          className="tilt-card reveal-left"
          style={{
            borderRadius: "10px",
            aspectRatio: "4/5",
            backgroundImage: `url(${storyphoto})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",

            //background: "linear-gradient(145deg,#4A7250,#243C28)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 24px 64px rgba(0,0,0,.4)",
            cursor: "default",
          }}
        >
          {[110, 165, 220].map((s, i) => (
            <div
              key={i}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
                width: `${s}px`,
                height: `${s}px`,
                border: `0.5px solid rgba(126,207,184,${0.14 - i * 0.04})`,
                borderRadius: "50%",
                pointerEvents: "none",
              }}
            />
          ))}

          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "45%",
              background: "linear-gradient(transparent,rgba(21,32,24,.65))",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "18px",
              left: "20px",
              right: "20px",
              fontFamily: "var(--font-serif)",
              fontStyle: "italic",
              fontSize: "12px",
              color: "rgba(255,255,255,.8)",
              zIndex: 1,
            }}
          >
            Together · 2026
          </div>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "38%",
              background: "linear-gradient(rgba(255,255,255,.05),transparent)",
              borderRadius: "10px 10px 0 0",
              pointerEvents: "none",
            }}
          />
        </div>
        {/* Message text */}
        <div className="reveal-right">
          <div className="section-tag" style={{ color: "var(--gold)" }}>
            A Note From Us
          </div>
          <h2
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: "clamp(28px,4vw,46px)",
              fontWeight: 300,
              lineHeight: 1.1,
              color: "#fff",
            }}
          >
            Words from{" "}
            <em style={{ fontStyle: "italic", color: "var(--sage)" }}>
              our hearts
            </em>
          </h2>
          <p
            style={{
              marginTop: "22px",
              fontFamily: "var(--font-serif)",
              fontStyle: "italic",
              fontSize: "17px",
              lineHeight: 1.95,
              color: "rgba(255,255,255,.7)",
              whiteSpace: "pre-line",
            }}
          >
            {WEDDING.message}
          </p>
          <div
            style={{
              marginTop: "28px",
              fontFamily: "var(--font-serif)",
              fontSize: "25px",
              fontStyle: "italic",
              color: "var(--sage-l)",
            }}
          >
            {WEDDING.groomName} & {WEDDING.brideName}
            <small
              style={{
                display: "block",
                fontStyle: "normal",
                fontFamily: "var(--font-sans)",
                fontSize: "9px",
                letterSpacing: ".2em",
                textTransform: "uppercase",
                color: "var(--muted)",
                marginTop: "6px",
              }}
            >
              With love, gratitude & joy · September 2026
            </small>
          </div>
        </div>
      </div>
    </section>
  );
}
